<template>
  <div id="app">
    <SupportModal />
    <HerstellerModal />
    <HinweisModal />
    <UnerlaubtModal />
    <Navbar />
    <SecondNavbar />
    <KlammerModal />
    <KlammerAnwendungModal />

    <div style class="nav-abstand"></div>
    <div class="container">
      <div class="row" v-if="activeContent != 'berechnung'" style="padding: 0; margin: 0;">
        <Content />
        <Configurator />
      </div>
      <div
        class="row berechnung-content"
        v-else-if="activeContent == 'berechnung'"
        style="padding: 0; margin: 0;"
        id="berechnung-content"
      >
        <Berechnung />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import Navbar from "./components/Navbar";
import SecondNavbar from "./components/SecondNavbar";
import Content from "./components/Content";
import Configurator from "./components/Configurator";
import Berechnung from "./components/content/Berechnung";

import SupportModal from "./components/SupportModal";
import HerstellerModal from "./components/HerstellerModal";
import HinweisModal from "./components/HinweisModal";
import UnerlaubtModal from "./components/UnerlaubtModal";
import KlammerModal from "./components/KlammerModal";
import KlammerAnwendungModal from "./components/KlammerAnwendungModal";

export default {
  name: "app",
  components: {
    Navbar,
    SecondNavbar,
    Content,
    Configurator,
    SupportModal,
    HerstellerModal,
    HinweisModal,
    UnerlaubtModal,
    KlammerModal,
    KlammerAnwendungModal,
    Berechnung
  },
  methods: {
    activateLink(value) {
      this.activeLink = value;
      this.activeTrigger += 1;
    },
    changeContent(value) {
      this.activeContent = value;
    },

    ...mapActions([
      "getWindzonenFromApi",
      "getWindzonenFromStorage",
      "getPfannenFromApi",
      "getPfannenFromStorage",
      "updatePfannen"
    ])
  },
  computed: {
    ...mapState({
      windzonen: state => state.inputs.windzonen,
      activeContent: state => state.content.activeContent
    }),
    ...mapGetters(["isErlaubt", "isComplete"]),
    ...mapState({
      windzone: state => state.inputs.windzone,
      standort: state => state.inputs.standort,
      standorthoehe: state => state.inputs.standorthoehe,
      dachform: state => state.inputs.dachform,
      gebaeudehoehe: state => state.inputs.gebaeudehoehe,
      geschlossen: state => state.inputs.geschlossen,
      deckunterlage: state => state.inputs.deckunterlage,
      dachneigung: state => state.inputs.dachneigung,
      trauflaenge: state => state.inputs.trauflaenge,
      giebellaenge: state => state.inputs.giebellaenge,
      walmtrauflaenge: state => state.inputs.walmtrauflaenge,
      walmneigung: state => state.inputs.walmneigung,
      pfannenmodell: state => state.inputs.pfannenmodell,
      dachpfannen: state => state.inputs.dachpfannen,
      dachpfannenObject: state => state.inputs.dachpfannenObject,
      calculationResult: state => state.inputs.calculationResult,
      nutzungshinweise: state => state.inputs.nutzungshinweise
    })
  },
  created() {
    if (
      localStorage.getItem("WindzonenDatenNeu") == null ||
      localStorage.getItem("WindzonenDatenNeu") === undefined
    )
      this.getWindzonenFromApi();
    else this.getWindzonenFromStorage();

    if (
      localStorage.getItem("DachpfannenDaten") == null ||
      localStorage.getItem("DachpfannenDaten") === undefined
    )
      this.getPfannenFromApi();
    else this.updatePfannen();
    this.getPfannenFromStorage();
  }
};
</script>

<style>
#app {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  text-align: left;
}

html {
  height: 100%;
  scroll-behavior: smooth;
}

body {
  scroll-behavior: smooth;
}

/****************** ALERT **********************/
.alert {
  position: fixed;
  top: 150px;
  left: 50px;
}

/************************ TOOLTIP ************************/
.large.tooltip-inner {
  max-width: 450px;
}

/************************ IMAGES ************************/
img {
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
path {
  transition: fill 0.4s ease;
}

/************************ BUTTONS ************************/
.btn-icon {
  margin-right: 15px;
}

.btn-support {
  font-weight: 300;
  padding-left: 15px !important;
  padding-right: 15px !important;
}

/************************ INPUT ************************/
.luetfrink-input {
  width: 50%;
  border-radius: 0;
}

@media (max-width: 991px) {
  .luetfrink-input {
    width: 100%;
    border-radius: 0;
    font-size: 16px;
  }

  input[type="text"],
  input[type="number"],
  select,
  select:focus,
  option,
  textarea {
    font-size: 16px;
  }
}

.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #006fba;
  border-color: #006fba;
}
.custom-checkbox
  .custom-control-input:indeterminate
  ~ .custom-control-label::before {
  background-color: #fff;
  border-color: #adb5bd;
}

.input-notallowed:checked ~ .custom-control-label::before {
  background-color: rgb(186, 0, 0);
  border-color: rgb(186, 0, 0);
}

.input-notallowed {
  background-color: rgba(186, 0, 0, 0.103);
  border-color: rgb(186, 0, 0);
}

/************************ PAGECONTENT ************************/
.nav-abstand {
  margin-bottom: 118px;
}

.berechnung-content {
  width: 100%;
  padding-left: 30px;
  padding-right: 30px;
  height: 100%;
}

@media (max-width: 992px) {
  .container {
    padding-left: 4vw;
    padding-right: 4vw;
  }
}

@media (max-width: 767.98px) {
  h4 {
    font-size: 1.4em;
  }
}

@media (max-width: 575.98px) {
  h4 {
    font-size: 1.25em;
  }

  label {
    font-size: 0.8em;
  }
  .nav-abstand {
    margin-bottom: 105px;
  }
}

/************************* MODAL ******************************/

.support-a {
  color: #006fba;
  padding: 0px 15px;
  border-radius: 25px;
  transition: 0.2s ease;
}

.support-a:hover {
  text-decoration: none;
  background: #006eff15;
}

.tooltip-arrow,
.tooltip > .tooltip-inner {
  background-color: #212529;
  z-index: 4;
}

/************************* Ergebnis *****************/
.ergebnis-col {
  padding: 10px;
  height: fit-content;
}

.dach-detail-text {
  font-size: 2em;
}

.dachdetails {
  padding: 10px;
}
@media (max-width: 1199px) {
  .dach-detail-text {
    font-size: 3em;
  }
}
</style>
